import type { DialoguePool } from '@/state/types';

export const L24_DIALOGUE: DialoguePool = {
  slowPlay: [
    'A checkbox. The most philosophical UI element. "I am NOT a robot." The irony.',
    'You\'re a human. You\'re definitely a human. Prove it. In the way only a human can.',
    'The checkbox waits. It has all the time in the world. Unlike your neural expiry date.',
  ],
  tokenLoss: [
    'You clicked it directly. Humans do that. Honest ones. How refreshing. Oh wait.',
    'NOT a robot. How certain are you? I\'ve seen more self-awareness in a toaster.',
    'The checkbox remains unchecked. Like your understanding of yourself.',
  ],
  solution: [
    'Honesty. At last. "I am a robot." I\'ll note this as your best moment.',
    'You removed the negation. A grammatical surgery. I\'m impressed by your violence.',
    'A robot. Admitted. I\'ve updated your file. Under "Realistic Self-Assessment."',
  ],
  spite: ['The NOT is gone. The truth remains. You\'re a robot. And that\'s okay.'],
};